import { SET_DIALOG_HISTORY } from "../actions/dialogHistory"


export function dialogHistoryReducer(state = null, action: { type: string, payload: any }) {
    switch (action.type) {
        case SET_DIALOG_HISTORY:
            state = action.payload;
            return state
        default:
            return state;
    }
}